import { apiClient } from "helpers/api_helper";

export const GetAllRepairWork = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/Repair/GetAllRepairWorkGrid`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};
